// @flow
import Swiper from 'swiper/swiper-bundle';
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	SWIPER: '[data-fragment="DefaultSwiper.swiper"]',
	PAGINATION: '[data-fragment="DefaultSwiper.pagination"]',
	PREV: '[data-fragment="DefaultSwiper.prev"]',
	NEXT: '[data-fragment="DefaultSwiper.next"]',
	SCROLLBAR: '[data-fragment="DefaultSwiper.scrollbar"]'
};

export default class DefaultSwiper extends WebComponent {

	didMount() {
		this.swiperEl = this.element.querySelector(fragments.SWIPER);
		const defaultOptions = {
			navigation: {
				nextEl: this.element.querySelector(fragments.NEXT),
				prevEl: this.element.querySelector(fragments.PREV)
			},
			pagination: {
				el: this.element.querySelector(fragments.PAGINATION),
				clickable: true
			},
			scrollbar: {
				el: this.element.querySelector(fragments.SCROLLBAR),
				draggable: true
			}
		};

		/*
		* Custom options lze definovat v HTML na hlavním elementu jako atribut ve tvaru: data-options='{"slidesPerView": 2, "spaceBetween": 10}'
		* HTML struktura je v html/wd/default-swiper.shtml
		* */
		let customOptions;
		if (this.element.dataset.options) {
			customOptions = JSON.parse(this.element.dataset.options);
		}
		const options = {
			...defaultOptions,
			...customOptions
		};
		this.swiper = new Swiper(this.swiperEl, options);
	}

	willUnmount() {
		this.slider.destroy();
	}
}


// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/DefaultSwiper.js